module.exports = __webpack_public_path__ + "static/media/29EUNOG8.c49b58ac.jpg";